<template>
  <div class="page-container">
    <div class="header">
      <div class="title">下载中心</div>
    </div>
    <div class="search-form">
      <el-form inline class="inline-form" label-width="100px">
        <el-form-item label="记录创建时间" size="small">
          <el-date-picker
            v-model="dateTimeRange"
            :picker-options="pickerOptions"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            size="small"/>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
          <el-button type="primary" @click="handleFormReset" class="bs-btn2">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tips-container">
      <p>温馨提示</p>
      <p>1、单次导出记录上限为100万条，若超过100万条，可能会造成导出失败，请注意控制导出记录数量；</p>
      <p>2、单次导出超过 50万条记录时，可能需要等待超过30分钟，请耐心等待；</p>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="130px"/>
        <el-table-column prop="latestDownloadTime" label="更新时间" align="center" min-width="130px">
          <template slot-scope="{row}">{{ row.latestDownloadTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="reportTypeName" label="报表类型" align="center" min-width="120px"/>
        <el-table-column prop="fileName" label="报表名称" align="center" min-width="150px"/>
        <el-table-column prop="status" label="生成状态" align="center" min-width="80px">
          <template slot-scope="{row}">{{ row.status | statusFilters }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="200px">
          <template slot-scope="{row}">{{ row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="120px">
          <template slot-scope="{row}">
            <el-button v-if="row.status === 2" type="text" @click="handleTableDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { queryDownloadList } from "@/api/download-center";
import {
  downLoadFileByForm,
} from "@/utils/index";
import { newHost } from "@/global-config";

const FORMAT_YMD = 'yyyy-MM-DD';
const FORMAT_YM = 'yyyy-MM';
const today = moment().format(FORMAT_YMD);
const startTime = '00:00:00';
const endTime = '23:59:59';
const defaultTime = [`${today} ${startTime}`, `${today} ${endTime}`];
export default {
  name: "download-center",
  data() {
    return {
      dateTimeRange: defaultTime,
      pickerOptions: {
        disabledDate(time) {
          const dayOf6MonthAgo = moment(moment().subtract(6, "month").format(FORMAT_YMD)).valueOf();
          return time < dayOf6MonthAgo || time > moment(`${today} ${endTime}`).valueOf();
        },
      },
      table: {
        data: [],
        loading: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  filters: {
    statusFilters(val) {
      const obj = {
        [-1]: '生成失败',
        0: '初始化',
        1: '生成中',
        2: '生成成功',
      };
      return obj[val] || '-';
    },
  },
  computed: {
    loginInfo() {
      const info = localStorage.getItem('LOGIN_INFO');
      return info ? JSON.parse(info) : {};
    },
  },
  mounted() {
    this.queryTableData();
  },
  methods: {
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.dateTimeRange = defaultTime;
    },
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    queryTableData() {
      const [createTimeStart, createTimeEnd] = this.dateTimeRange || [];
      if (!createTimeStart || !createTimeEnd) {
        this.$message.warning('请选择记录创建时间');
        return;
      }
      const { pageNo, pageSize } = this.table;
      const params = {
        createTimeStart,
        createTimeEnd,
        pageNo,
        pageSize,
      };
      this.table.loading = true;
      queryDownloadList(params).then(({ data: { code, data, msg } }) => {
        this.table.loading = false;
        if (code === '0') {
          this.table.data = data.records;
          this.table.totalCount = data.totalCount;
        }
      });
    },
    handleTableDownload({ id }) {
      const { userName, sessionId } = this.loginInfo;
      window.open(`${newHost}/downloadCenter/download?id=${id}&userName=${userName}&sessionId=${sessionId}`);
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;
  }

  .tips-container {
    padding: 40px 50px 0;

    p {
      font-size: 18px;
      font-weight: 500;
      line-height: 27px;
      color: #27364d;

      &:not(:first-child) {
        font-size: 14px;
        color: #f00;
      }
    }
  }

  .table-container {
    padding: 40px 50px;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>
